import { TOCContextState } from '../interfaces/toc';

export const TOC_CONTEXT_INITIAL_STATE: TOCContextState = {
  items: [],
  activeItem: null,
  contentContainerRef: null,
  registerItem: () => {},
  jumpToSection: () => {},
  setActiveItem: () => {}
};
